import { render, staticRenderFns } from "./BaseForecastModalPage.vue?vue&type=template&id=6ab1e2cd"
import script from "./BaseForecastModalPage.vue?vue&type=script&lang=ts"
export * from "./BaseForecastModalPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports